const STEPS = ['WhatsApp', 'AI Provider', 'Language', 'Tracking', 'Data Sharing', 'Finish'];

interface SetupProgressProps {
  currentStep: number;
}

export function SetupProgress({ currentStep }: SetupProgressProps) {
  return (
    <div className="flex gap-2 mb-6">
      {STEPS.map((label, i) => {
        const stepNum = i + 1;
        const isCompleted = stepNum < currentStep;
        const isCurrent = stepNum === currentStep;
        return (
          <div key={label} className="flex-1 flex flex-col items-center gap-1">
            <div
              className={`w-full h-1 rounded-full transition-colors duration-300 ${
                isCompleted
                  ? 'bg-accent'
                  : isCurrent
                    ? 'bg-accent/50'
                    : 'bg-edge'
              }`}
            />
            <span
              className={`text-xs transition-colors duration-200 ${
                isCompleted || isCurrent ? 'text-ink font-medium' : 'text-ink-tertiary'
              }`}
              data-ph-no-mask
            >
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
